const WaitForApiLoad = () => {
  // Replace this with real API calls or await your actual fetch functions
  return new Promise((resolve) => {
    setTimeout(resolve, 100); // simulate 0.1s API call
  });
};

export default WaitForApiLoad;
